// Stable FNV-1a hashing with a final avalanche for independent keyed draws.
export function stableHash(value: string): number {
  let result = 2166136261
  for (let index = 0; index < value.length; index += 1) {
    result = Math.imul(result ^ value.charCodeAt(index), 16777619)
  }
  result ^= result >>> 16
  result = Math.imul(result, 0x7feb352d)
  result ^= result >>> 15
  result = Math.imul(result, 0x846ca68b)
  result ^= result >>> 16
  return result >>> 0
}

export function deterministicDraw(key: string): number {
  return stableHash(key) / 0x100000000
}
